export type IEnv = 'localprod' | 'prod' | 'stage' | 'test' | 'dev' | 'local';

const env: {
  ENV: IEnv;
} = {
  ENV: process.env.ENV ? (process.env.ENV.toLowerCase() as any) : 'test'
};

export default env;
